import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const SECTIONS = [
  {
    h: "1. Acceptance of Terms",
    p: "By accessing or using dompryce.com you agree to these Terms of Service. If you do not agree, please do not use the service.",
  },
  {
    h: "2. What Dompryce is",
    p: "Dompryce is an independent price-comparison engine. We aggregate pricing and availability data from third-party registrars (Namecheap, GoDaddy, Porkbun, Cloudflare, Spaceship, Dynadot, Hostinger and others). We do not sell, register, manage, or transfer domains ourselves.",
  },
  {
    h: "3. Pricing accuracy",
    p: "We refresh registrar pricing daily and verify availability via RDAP, but prices, promotions, and TLD support can change without notice. The price shown on the registrar's checkout page is the binding price.",
  },
  {
    h: "4. AI-generated content",
    p: "Domain name suggestions are AI-generated and are provided as inspiration. We do not guarantee that suggested names are trademark-safe — you are responsible for performing your own trademark and legal review before registering.",
  },
  {
    h: "5. Affiliate disclosure",
    p: "Some outbound \"Buy here\" links may earn us a commission at no additional cost to you. Affiliate relationships never influence our rankings or the price you pay.",
  },
  {
    h: "6. User accounts",
    p: "When you sign in with Google, you must provide accurate information and keep your credentials secure. You are responsible for activity under your account. We may suspend accounts that violate these terms or applicable law.",
  },
  {
    h: "7. Acceptable use",
    p: "You agree not to: scrape the site at scale, abuse our APIs, reverse engineer the service, infringe intellectual property, or use Dompryce to facilitate spam, fraud, phishing, or trademark squatting.",
  },
  {
    h: "8. Intellectual property",
    p: "All content on Dompryce (excluding third-party registrar logos and trademarks, which belong to their respective owners) is © Dompryce and may not be reproduced without permission.",
  },
  {
    h: "9. Warranty disclaimer",
    p: "The service is provided \"as is\" and \"as available\" without warranty of any kind, express or implied. We do not warrant that the service will be uninterrupted, error-free, or that any data shown will be accurate at all times.",
  },
  {
    h: "10. Limitation of liability",
    p: "To the maximum extent permitted by law, Dompryce will not be liable for any indirect, incidental, special, consequential or punitive damages arising from your use of the service.",
  },
  {
    h: "11. Changes & termination",
    p: "We may modify these Terms at any time. Continued use after changes are posted constitutes acceptance. We may suspend or terminate the service at any time.",
  },
  {
    h: "12. Governing law",
    p: "These Terms are governed by the laws of India. Disputes will be resolved in the competent courts of Bengaluru, India.",
  },
  {
    h: "13. Contact",
    p: "Questions about these Terms? Email support@dompryce.com.",
  },
];

export default function Terms() {
  return (
    <Layout>
      <Seo
        title="Terms of Service"
        description="The rules that govern your use of Dompryce — the independent domain price comparison and AI domain naming platform."
        path="/terms"
      />
      <article className="mx-auto max-w-3xl py-8" data-testid="terms-page">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">Legal</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-zinc-900 md:text-5xl">
          Terms of Service
        </h1>
        <p className="mt-3 text-sm text-zinc-500">Last updated: February 2026</p>

        <div className="mt-10 space-y-8 text-base leading-relaxed text-zinc-700">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl font-semibold text-zinc-900">{s.h}</h2>
              <p className="mt-2">{s.p}</p>
            </section>
          ))}
        </div>
      </article>
    </Layout>
  );
}
